import Navbar from './elements/Navbar';

function App() {

  return (
    <div className="App">
      <Navbar />
      <div className="container mx-auto">
        <div className="updaterWrapper">
          <div className="space-y-12">
            <h1 className="text-2xl font-semibold leading-7 text-gray-900">Introduction</h1>
            <p className="mt-1 leading-6" style={{marginTop: "1rem"}}>There was a need for an internal application that would allow different members of the team to bulk-update Product fields by using the Matrixify app. This application was created to help with that process. The application is split into two parts: the Metafield Updater and the Tag Updater. The Metafield Updater allows you to update the metafields of your products in bulk. The Tag Updater allows you to either <span className="font-bold">MERGE</span> or <span className="font-bold">DELETE</span> tags from your Shopify store. This app is useful for bulk updating tags on products.
            </p>
            <div className="border-b border-gray-900/10 pb-12">
              <h2 className="text-base font-semibold leading-7 text-gray-900">Helpful Resources</h2>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                Below is a list of resources to help you understand how the Matrixify applications works, and how to properly manage Products in Shopify. This application will grow over time as more features are added.
              </p>
              <ul className="mt-4">
                <li className="text-sm leading-6 text-gray-600"><a href="https://matrixify.app/documentation/" className="text-blue-600">Matrixify Documentation</a></li>
                <li className="text-sm leading-6 text-gray-600"><a href="https://help.shopify.com/en/manual/custom-data/metafields" className="text-blue-600">Shopify Metafield Documentation</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;